import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-no-data-alert',
  templateUrl: './no-data-alert.component.html',
  styleUrls: ['./no-data-alert.component.scss']
})
export class NoDataAlertComponent implements OnInit {
  @ViewChild('alert', { static: true }) alert: ElementRef;
  closeAlert() {
    this.alert.nativeElement.classList.remove('show');
  }
  constructor() { }

  ngOnInit() {
  }

}
